import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EditSchedulingBlocks } from '../../SelfScheduling/components/form/editScheduleBlocks/EditScheduleBlocks';

const SchedulingTimesField = ({ value, onChange, disabled }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const onChangeBlocks = (newValue) => {
    setCurrentValue(newValue);
    if (onChange != null) onChange(newValue);
  };

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  return (
    <>
      <EditSchedulingBlocks days={currentValue} onChange={onChangeBlocks} disabled={disabled} />
    </>
  );
};

export default SchedulingTimesField;
SchedulingTimesField.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
